const autocompleteModalCloneCheck = {
  serviceType: 'Tipo do Serviço',
  frequency: 'Periodicidade',
  mandatory: 'Serviço é obrigatório?'
};

export default autocompleteModalCloneCheck;
